<myvf-ui-alert *ngIf="isShow" [title]="'Info'" (close)="handleClose()" (retry)="handleRetry()"
  >{{ message }}
</myvf-ui-alert>
